import csTools from "cornerstone-tools";
const BaseBrushTool = csTools.importInternal("base/BaseBrushTool");
const external = csTools.external;
const segmentationUtils = csTools.importInternal("util/segmentationUtils");
import getCircle from "./get-circle";
const drawBrushPixels = segmentationUtils.drawBrushPixels;

import renderCircleEraserMixin from "./render-brush-mixins/render-circle-eraser-mixin";
// Register custom mixin
csTools.register("mixin", "renderCircleEraserMixin", renderCircleEraserMixin);

/**
 * @public
 * @class EraseCircleBrushTool
 * @memberof Tools.EraseCircleBrushTool
 * @classdesc Tool for erase segmentations on an image.
 * @extends Tools.Base.BaseBrushTool
 */
export class EraseCircleBrushTool extends BaseBrushTool {
  constructor(props = {}) {
    const defaultProps = {
      name: "EraseCircleBrush",
      supportedInteractionTypes: ["Mouse", "Touch"],
      configuration: {},
      mixins: ["renderCircleEraserMixin"],
    };

    super(props, defaultProps);

    this.touchDragCallback = this._paint.bind(this);
  }

  /**
   * Clear the data from the labelmap.
   *
   * @protected
   * @param  {Object} evt The data object associated with the event.
   * @returns {void}
   */
  _paint(evt) {
    const eventData = evt.detail;
    const { rows, columns } = eventData.image;
    const { x, y } = eventData.currentPoints.image;

    if (x < 0 || x > columns || y < 0 || y > rows) {
      return;
    }

    const radius = csTools.getModule("segmentation").configuration.radius;
    const pointerArray = getCircle(
      radius,
      rows,
      columns,
      x,
      y,
      eventData.image.rowPixelSpacing
    );
    const { labelmap2D, labelmap3D } = this.paintEventData;

    // Erase the active color.
    drawBrushPixels(
      pointerArray,
      labelmap2D.pixelData,
      labelmap3D.activeSegmentIndex,
      columns,
      true
    );

    external.cornerstone.updateImage(evt.detail.element);
  }
}
